/**
 * The application features set that can be enabled/disabled
 */
export enum Feature {
    /**
     * Login into the app
     */
    LOGIN = "login",
    /**
     * Register an account via mail link
     */
    REGISTER = "register",
    /**
     * Reset forgotten password
     */
    RESET_PASSWORD = "reset-password",
    /**
     * View and edit profile pages
     */
    PROFILE = "profile",
    /**
     * Validated skills list inside the profile page
     */
    PROFILE_SKILLS_VIEW = "profile-skills-view",
    /**
     * List classrooms inside profile page
     */
    PROFILE_CLASSROOMS_VIEW = "profile-classrooms-view",
    /**
     * Manage notifications inside profile and see them in the app header
     */
    NOTIFICATIONS = "notifications",
    /**
     *  Access homepage
     */
    HOMEPAGE = "homepage",
    /**
     *  Access classroom homepage cards
     */
    HOMEPAGE_CLASSROOM_CARD = "homepage-classroom-card",
    /**
     *  Access framework homepage cards
     */
    HOMEPAGE_FRAMEWORKS_CARD = "homepage-frameworks-card",
    /**
     *  Access metrics homepage cards
     */
    HOMEPAGE_METRICS_CARD = "homepage-metrics-card",
    /**
     *  Access learners homepage cards
     */
    HOMEPAGE_LEARNERS_CARD = "homepage-learners-card",
    /**
     *  Access briefs homepage cards
     */
    HOMEPAGE_BRIEFS_CARD = "homepage-briefs-card",
    /**
     * Access resources homepage cards
     */
    HOMEPAGE_RESOURCES_CARD = "homepage-resources-card",
    /**
     * Access Pedagogical Scenario homepage cards
     */
    HOMEPAGE_SCENARIO_CARD = "homepage-scenario-card",
    /**
     * List user classrooms, select an active classroom and view its details
     */
    SELECT_ACTIVE_CLASSROOM = "select-active-classroom",
    /**
     * View classroom metrics card
     */
    CLASSROOM_METRICS = "classroom-metrics",
    /**
     * Export classroom statistics
     */
    EXPORT_CLASSROOM_STATISTICS = "export-classroom-statistics",
    /**
     * View classroom metrics TODO
     */
    CLASSROOM_METRICS_TRAINER = "classroom-metrics-trainer",
    /**
     * View classroom leaners card
     */
    CLASSROOM_LEARNERS = "classroom-learners",
    /**
     * List briefs assigned to classroom
     */
    CLASSROOM_BRIEFS = "classroom-briefs",
    /**
     * Assign and Unassign brief for the classroom
     */
    CLASSROOM_BRIEFS_MANAGE = "classroom-briefs-manage",
    /**
     * TODO: define scope
     */
    CLASSROOM_BRIEFS_SUBMIT = "classroom-briefs-submit",
    /**
     * Update classroom properties and learners
     */
    CLASSROOM_UPDATE = "classroom-update",
    /**
     * Update classroom learners
     */
    CLASSROOM_UPDATE_LEARNERS = "classroom-update-learners",
    /**
     * Create a new classroom
     */
    CLASSROOM_CREATE = "classroom-create",
    /**
     * Join the classroom webinar
     */
    CLASSROOM_WEBINAR = "classroom-webinar",
    /**
     * Download classroom balance sheet
     */
    CLASSROOM_DOWNLOAD_BALANCE_SHEET = "classroom-download-balance-sheet",

    /**
     * Can delete comments
     */
    COMMENTS_EDIT = "comments:edit",

    /**
     * View FrameworksCard for the active classroom frameworks
     */
    HOMEPAGE_CLASSROOM_SCOPED_FRAMEWORKS = "homepage-classrooms-scoped-frameworks",

    // WIP: define more feature flags and scopes

    BRIEFS = "briefs",
    BRIEFS_EXPLORE = "briefs:explore",
    BRIEFS_CREATE = "briefs:create",
    BRIEFS_EDIT = "briefs:edit",
    BRIEFS_DELETE = "briefs:delete",
    BRIEFS_EDIT_COEDITORS = "briefs:edit:coeditors",
    BRIEFS_DUPLICATE = "briefs:duplicate",
    BRIEFS_MANAGE = "briefs:manage",
    BRIEFS_ADMIN = "briefs:admin",
    CURRENT_BRAND_WRITE = "currentBrand:write",

    FRAMEWORKS_ADMIN_READ = "frameworks:admin:read",
    FRAMEWORKS_ADMIN_WRITE = "frameworks:admin:write",
    FRAMEWORKS_ADMIN_WRITE_ANY_BRAND = "frameworks:admin:write:anyBrand",

    FRAMEWORKS_ADMIN_DUPLICATE = "frameworks:admin:duplicate",

    SKILLS_ADMIN_READ = "skills:admin:read",
    SKILLS_ADMIN_WRITE = "skills:admin:write",
    SKILLS_ADMIN_WRITE_ANY_BRAND = "skills:admin:write:anyBrand",

    SKILL_DOMAINS_ADMIN_READ = "skillDomains:admin:read",
    SKILL_DOMAINS_ADMIN_WRITE = "skillDomains:admin:write",

    SKILL_BLOCKS_ADMIN_READ = "skillBlocks:admin:read",
    SKILL_BLOCKS_ADMIN_WRITE = "skillBlocks:admin:write",

    FRAMEWORKS_ADMIN_TRANSLATIONS_READ = "frameworks:admin:translations:read",
    SKILLS_ADMIN_TRANSLATIONS_READ = "skills:admin:translations:read",

    ADMIN = "admin",
    ADMIN_PAGES_MANAGE = "admin-pages:manage",
    ADMIN_PAGES_DELETE = "admin-pages:delete",
    ADMIN_ANNOUNCEMENTS_MANAGE = "admin-announcements:manage",
    LANGUAGES_VIEW = "languages:view",
    LANGUAGES_MANAGE = "languages:manage",
    TAGS_VIEW = "tags:view",
    TAGS_MANAGE = "tags:manage",
    CATEGORIES_VIEW = "categories:view",
    CATEGORIES_MANAGE = "categories:manage",
    CERTIFICATION_ISSUERS_MANAGE = "certification-issuers:manage",
    TOPICS = "topics",
    /**
     * Correct an individual work
     */
    TOPICS_WORK_EVAL = "topics-work-eval",
    /**
     * Submit an individual work
     */
    TOPICS_WORK_SUBMIT = "topics-workspace-submit",
    /**
     * Send messages in individual work
     */
    TOPICS_MESSAGE = "topics-message",
    /**
     * Access the group workspace
     */
    WORKSPACE_GROUP = "workspace-group",
    /**
     * Correct group work
     */
    WORKSPACE_GROUP_CORRECTION = "workspace-group-correction",
    /**
     * Submit a work in a group workspace
     */
    WORKSPACE_GROUP_SUBMIT = "workspace-group-submit",
    /**
     * Manage a group workspace
     */
    WORKSPACE_GROUP_MANAGE = "workspace-group-manage",
    /**
     * Send message to a workspace group
     */
    WORKSPACE_GROUP_MESSAGE = "workspace-group-message",

    /**
     * Can view follow-ups
     */
    FOLLOW_UPS = "follow-ups",
    /**
     * Can select learner to list its follow ups
     */
    FOLLOW_UPS_LIST_LEARNER_SELECT = "follow-ups:list:learner-select",
    /**
     * Can create follow-up
     */
    FOLLOW_UPS_CREATE = "follow-ups:create",
    FOLLOW_UPS_CREATE_LEARNER = "follow-ups:create:learner",
    FOLLOW_UPS_CREATE_TRAINER = "follow-ups:create:trainer",
    FOLLOW_UPS_CREATE_TUTOR = "follow-ups:create:tutor",
    FOLLOW_UPS_CREATE_MANAGER = "follow-ups:create:manager",

    /**
     * Can edit follow up
     */
    FOLLOW_UPS_EDIT = "follow-ups:edit",
    FOLLOW_UPS_EDIT_LEARNER = "follow-ups:edit:learner",
    FOLLOW_UPS_EDIT_TRAINER = "follow-ups:edit:trainer",
    FOLLOW_UPS_EDIT_TUTOR = "follow-ups:edit:tutor",
    FOLLOW_UPS_EDIT_MANAGER = "follow-ups:edit:manager",

    /** Can receive notifications as learner */
    FOLLOW_UPS_NOTIFICATIONS_LEARNER = "follow-ups:notifications:learner",

    /**
     * Manage a learner's tutors
     */
    USERS_MANAGE_TUTORS = "users:manage-tutors",

    /**
     * Access resources space
     */
    RESOURCES = "resources",
    /**
     * Create a new resource as a trainer
     */
    RESOURCE_CREATE_TRAINER = "resource:create:trainer",
    /**
     * Create a new resource as a learner
     */
    RESOURCE_CREATE_LEARNER = "resource:create:learner",
    /**
     * Delete a resource from the active classroom
     */
    RESOURCE_DELETE = "resource-delete",
    /**
     * Update a resource
     */
    RESOURCE_UPDATE = "resource-udpate",
    /**
     * Access Professional Situation ressources
     */
    PROFESSIONAL_SITUATION = "professional-situation",
    /**
     * Read the professional situation details from a brief
     */
    PROFESSIONAL_SITUATION_DETAILS = "professional-situation-details",
    /**
     * Create a professional situation
     */
    PROFESSIONAL_SITUATION_CREATE = "professional-situation-create",
    /**
     * Delete a professional situation
     */
    PROFESSIONAL_SITUATION_DELETE = "professional-situation-delete",
    /**
     * Edit a professional situation
     */
    PROFESSIONAL_SITUATION_UPDATE = "professional-situation-update",
    /**
     * Manage the classroom pedagogical scenario
     */
    PEDAGOGICAL_SCENARIO_MANAGE = "pedagogical-scenario-manage",
    /**
     * See the pedagogical scenario details table
     */
    PEDAGOGICAL_SCENARIO_DETAILS = "pedagogical-scenario-details",

    /**
     * Create a mission
     */
    MISSION_CREATE = "mission-create",

    /**
     * Menu Items
     */
    MENU_HOME = "menu-home:access",
    /**
     * Menu trainer space
     */
    MENU_TRAINER_SPACE = "menu-trainer-space:access",
    /**
     * Menu classroom space
     */
    MENU_CLASSROOM_SPACE = "menu-classroom-space:access",
    MENU_CLASSROOM_DASHBOARD = "menu-classroom-dashboard:access",
    MENU_AGENDA = "menu-agenda:access",

    MENU_BRIEFS_EXPLORER = "menu-briefs-explorer:access",
    MENU_FOLLOW_UPS = "menu-follow-ups:access",
    /**
     * Show classroom selector in settings page (learner only)
     */
    SETTINGS_CLASSROOM_SELECT = "settings-classroom-select:access",

    /**
     * Menu layout flag for learner-specific sidebar
     */
    MENU_LAYOUT_LEARNER = "menu-layout:learner",

    /**
     * Menu quick links
     */
    MENU_QUICK_LINKS_BRIEF_CREATE = "menu-quick-link-briefs:create",
    MENU_QUICK_LINKS_PROFESSIONAL_SITUATION_CREATE = "menu-quick-link-professional-situation:create",

    FRAMEWORKS_ACCESS_TUTOR = "frameworks:access:tutor",
    FRAMEWORKS = "frameworks:access",
    ADMIN_STATISTICS = "admin-statistics:access",

    PEDAGOGICAL_SCENARIO = "pedagogical-scenario:access",
    PEDAGOGICAL_SCENARIO_MANAGE_PERIODS = "pedagogical-scenario:manage-periods",

    CLASSROOM = "classroom:access",
    WORKSPACES_ACCESS_TUTOR = "workspaces:access:tutor",

    /**
     * Trainer homepage
     */
    HOMEPAGE_TRAINER = "homepage:access:trainer",
    /**
     * Learner homepage
     */
    HOMEPAGE_LEARNER = "homepage:access:learner",
    /**
     * Manager homepage
     */
    HOMEPAGE_MANAGER = "homepage:access:manager",
    /**
     * Tutor homepage
     */
    HOMEPAGE_TUTOR = "homepage:access:tutor",

    LEARNERS_CARD_ACCESS_TUTOR = "learners-card:access:tutor",

    /**
     * Can use active classroom context
     */
    HAS_ACTIVE_CLASSROOM_CTX = "has-active-classroom-ctx",

    /**
     * Can submit reflective analysis
     */
    REFLECTIVE_ANALYSIS_SUBMIT = "reflective-analysis:submit",

    /**
     * Toggle dark mode
     */
    DARK_MODE = "dark-mode",

    /**
     * View classroom statistics page
     */
    CLASSROOM_STATISTICS = "classroom-statistics:access",

    /**
     * Manage training templates
     */
    TRAINING_TEMPLATES_MANAGE = "training-templates:manage",

    /**
     * Archive a training template
     */
    TRAINING_TEMPLATES_ARCHIVE = "training-templates:archive",

    /**
     * View learner progression
     */
    CLASSROOM_LEARNER_PROGRESSION = "classroom-learner-progression:access",

    /**
     * Agenda gesture access (view, create, edit, delete)
     */
    AGENDA = "agenda:access",

    /**
     * Manage classroom templates
     */
    USE_CLASSROOM_TEMPLATES = "classroom-templates:manage",

    /**
     * Manage Agenda
     */
    AGENDA_EVENT_CREATE_PEDAGOGICAL = "agenda-event:create-pedagogical",
    AGENDA_EVENT_CREATE_CLASSROOM = "agenda-event:create-classroom",
    AGENDA_EVENT_DUPLICATE_PEDAGOGICAL = "agenda-event:duplicate-pedagogical",
    AGENDA_EVENT_DUPLICATE_CLASSROOM = "agenda-event:duplicate-classroom",
    AGENDA_EVENT_EDIT_PEDAGOGICAL = "agenda-event:edit-pedagogical",
    AGENDA_EVENT_EDIT_CLASSROOM = "agenda-event:edit-classroom",
    AGENDA_EVENT_DELETE_PEDAGOGICAL = "agenda-event:delete-pedagogical",
    AGENDA_EVENT_DELETE_CLASSROOM = "agenda-event:delete-classroom",
    AGENDA_EVENT_DRAG_PEDAGOGICAL = "agenda-event:drag-pedagogical",
    AGENDA_EVENT_DRAG_CLASSROOM = "agenda-event:drag-classroom",

    /**
     * Syllabus Gesture
     */
    SYLLABUS_READ = "syllabus:read",

    /**
     * Learner workspace listing every assigned brief in the active classroom
     */
    MY_WORKSPACE = "my-workspace:access",
}

/**
 * NOTE: This enum will be completed as the project grows.
 */

export default Feature;
